import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-status-badge-active.svg";
import { ReactComponent as NormalImg } from "../../../img/ico-account-sleeper.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-account-idle.svg";
import { ReactComponent as LockImg } from "../../../img/ico-account-lock.svg";
import { ReactComponent as WithdrawImg } from "../../../img/ico-account-withdraw.svg";
import { ReactComponent as InactiveImg } from "../../../img/ico-status-badge-idle.svg";
import { ReactComponent as RestoringImg } from "../../../img/ico-status-badge-commit.svg";
import { ReactComponent as LockedImg } from "../../../img/ico-status-badge-lock.svg";
import { ReactComponent as MigrationImg } from "../../../img/ico-status-badge-migration.svg";
import { ReactComponent as PoweringUpImg } from "../../../img/ico-status-badge-on.svg";
import { ReactComponent as PoweringDownImg } from "../../../img/ico-status-badge-off.svg";
import { ReactComponent as PausedImg } from "../../../img/ico-status-badge-pause.svg";
import { ReactComponent as SuspendImg } from "../../../img/ico-status-badge-stop.svg";
import { ReactComponent as RebootImg } from "../../../img/ico-status-badge-restart.svg";
import { ReactComponent as WaitForLaunchImg } from "../../../img/ico-status-badge-ready.svg";
import { ReactComponent as SavingImg } from "../../../img/ico-status-badge-sleep.svg";
import { ReactComponent as NotRespondingImg } from "../../../img/ico-status-badge-no-response.svg";
import { ReactComponent as UnknwonImg } from "../../../img/ico-status-badge-unknown.svg";


import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { DropdownType } from "../../base/CustomDropdown";
import ClusterAdd from "./ClusterAdd";
import ClusterUpdate from "./ClusterUpdate";
import { numberOfCommas, parseLocaleDatetime } from "common/util";

export interface ClusterData {
    container_cluster_id: string,
    container_cluster_name: string,
    container_cluster_description: string,
    container_cluster_status_code: string;
    container_cluster_health_yn: boolean;
    master_node_count: number,
    labels: string,
    worker_node_count: number,
    creation_timeout_min: number,
    stack_status_reason: string,
    container_cluster_template: {
        container_cluster_template_id: string,
        container_cluster_template_name: string
    },
    vm_type: {
        vm_type_id: string
    },
    master_vm_type: {
        vm_type_id: string
    },
    project: {
        project_id: string
        project_name : string
    },
    availability_zone: {
        availability_zone_id: string
    },
    status_reason?: string;
    health_reason?: string;
    create_ts: string,
    update_ts: string,
}

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("CLUSTER_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "CLUSTER_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {

        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "CLUSTER_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "CLUSTER_SYNC",
        },
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("CONTAINER_CLUSTER_NAME_TEXT"),
        accessor: "container_cluster_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("STATUS_TEXT"),
        accessor: "container_cluster_status_code",  // TODO Upate
        disableSortBy: true,
        style: {
            width: "120px",
            paddingLeft: 15
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.statusContainer}>
                {
                    (() => {
                        if(value === "CRATCMPT" || value === "UPDTCMPT" || value === "DELCMPT" || value === "RSUMCMPT"  || value === "RBACKCMPT"  || value === "SNAPCMPT"   || value === "CHCKCMPT"   || value === "ADPTCMPT")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#333"}}>
                                <NormalImg style={className.statusImg}/>
                                <>{
                                    value === "CRATCMPT" ? i18n.t("CREATE_COMPLETE_TEXT")
                                    : value === "UPDTCMPT" ? i18n.t("UPDATE_COMPLETE_TEXT")
                                    : value === "DELCMPT" ? i18n.t("DELETE_COMPLETE_TEXT")
                                    : value === "RSUMCMPT" ? i18n.t("RESUME_COMPLETE_TEXT")
                                    : value === "RBACKCMPT" ? i18n.t("ROLLBACK_COMPLETE_TEXT")
                                    : value === "SNAPCMPT" ? i18n.t("SNAPSHOT_COMPLETE_TEXT")
                                    : value === "CHCKCMPT" ? i18n.t("CHECK_COMPLETE_TEXT")
                                    : i18n.t("ADAPT_COMPLETE_TEXT")
                                }</>
                            </div>)
                        else if(value === "CRTFAIL" || value === "UPDTFAIL" || value === "DELFAIL" || value === "RSUMFAIL" || value === "RBACKFAIL")
                            return (
                                <div style={{...className.statusInnerContainer, color:"#333"}}>
                                <IdleImg style={className.statusImg}/>
                                <>{
                                    value === "CRTFAIL" ? i18n.t("CREATE_FAIL_TEXT")
                                    : value === "UPDTFAIL" ? i18n.t("UPDATE_FAIL_TEXT")
                                    : value === "DELFAIL" ? i18n.t("DELETE_FAIL_TEXT")
                                    : value === "RSUMFAIL" ? i18n.t("RESUME_FAIL_TEXT")
                                    : i18n.t("ROLLBACK_FAIL_TEXT")
                                }</>
                            </div>)
                        else
                            return (
                                <div style={{...className.statusInnerContainer, color:"#333"}}>
                                <LockImg style={className.statusImg}/><>{i18n.t("LOCK_TEXT")}</>
                            </div>)
                    })()
                }
            </div>
        )
    },
    // {
    //     Header: i18n.t("CONTAINER_CLUSTER_HEALTH_TEXT"),
    //     accessor: "container_cluster_health_yn",
    //     disableSortBy: true,
    //     style: {
    //         width: "100px",
    //         paddingLeft: 10,
    //     },
    //     Cell: ({ cell: {value} }) => (
    //         <div style={{
    //             display: "flex", alignItems: "center",
    //             fontFamily: FONT.REGULAR,
    //             fontSize: 12,
    //             color: value ? "#3a8344" : "#8c8c8c",
    //         }}>
    //             {
    //                 value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
    //             }
    //             {
    //                 value ? "Active" : "Down"
    //             }
    //         </div>
    //     )
    // },
    {
        Header: i18n.t("API_ADDRESS_TEXT"),
        accessor: "api_server_address", // TODO Upate
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.blueText}}>{value}</div>
        )
    },
    {
        Header: i18n.t("CONTAINER_CLUSTER_MASTER_COUNT"),
        accessor: "master_node_count",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.blueText}}>{numberOfCommas(value)}</div>
        )
    },
    {
        Header: i18n.t("CONTAINER_CLUSTER_NODE_COUNT"),
        accessor: "node_count",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.greenText}}>{numberOfCommas(value)}</div>
        )
    },
    {
        Header: i18n.t("CONTAINER_CLUSTER_POD_COUNT"),
        accessor: "pod_count",   // TODO Upate
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.greenText}}>{numberOfCommas(value)}</div>
        )
    },
    {
        Header: i18n.t("VOLUME_SIZE_TEXT"),
        accessor: "volume_size_gb",   // TODO Upate
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}GB</div>
        )
    },
    {
        Header: i18n.t("KEY_PAIR_NAME_TEXT"),
        accessor: "vm_key_pair_name",    // TODO Upate
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}</div>
        )
    },
    {
        Header: i18n.t("TEMPLATE_TEXT"),
        accessor: "container_cluster_template", // TODO Upate
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value?.container_cluster_template_name ? value?.container_cluster_template_name : '-'}</div>
        )
    },
    {
        Header: i18n.t("PROJECT_TEXT"),
        accessor: "project",   // TODO Upate
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value?.project_name ? value.project_name : '-'}</div>
        )
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value ? parseLocaleDatetime(value)  : '-'}
            </div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.dateContainer}}>
                {value ? parseLocaleDatetime(value)  : '-'}
            </div>
        )
    },
];


export const clusterAddModalContent = {
    title: i18n.t("CONTAINER_CLUSTER_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <ClusterAdd />,
}

export const clusterUpdateModalContent = {
    title: i18n.t("CONTAINER_CLUSTER_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <ClusterUpdate />,
}



const className = {
    statusContainer: {
        width: 126,
        display: "flex", justifyContent: "center",
        borderRadius: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    nameTextContainer: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    blueContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    },
    greenText: {
        color: "#3a8344"
    },
    statusImg: {
        marginRight: 3
    },

    statusInnerContainer: {
        display: "flex", alignItems: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#616266",
        overflow: "hidden"
    },
}